export const UnitPermissions = {
  ViewAndSearchInPropertyManagementUnits:
  {
    permissionsId: 'd7be1f48-daa4-4aec-c9cc-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Units',
    componentsId: null,
    components: null
  },
  ViewProperties: {
    components: null,
    componentsId: null,
    permissionsId: '375b1e8c-8c03-4de7-930e-08d967db92be',
    permissionsName: 'View properties'
  },
  ViewContacts: {
    components: null,
    componentsId: null,
    permissionsId: '2dfaa547-246c-4aac-930f-08d967db92be',
    permissionsName: 'View contacts'
  },
  AddNewUnit: {
    components: null,
    componentsId: null,
    permissionsId: '381abdf9-cea2-463a-9310-08d967db92be',
    permissionsName: 'add new unit'
  },
  UploadUnit:
  {
    permissionsId: 'd8920be2-c523-4b0f-0d58-08d96c602a6b',
    permissionsName: 'upload unit',
    componentsId: null,
    components: null
  },
  ImportUnit:
  {
    permissionsId: '88190a2b-cf07-473c-9312-08d967db92be',
    permissionsName: 'Import unit',
    componentsId: null,
    components: null
  },

  EditUnitMarketingInfo: {
    components: null,
    componentsId: null,
    permissionsId: '6fca612e-92c5-47d9-9313-08d967db92be',
    permissionsName: 'Edit unit marketing info'
  },

  AddNewRemarksForUnit: {
    components: null,
    componentsId: null,
    permissionsId: '21d4142b-0c20-4aae-9314-08d967db92be',
    permissionsName: 'Add new remarks for unit'
  },

  ViewReferenceDetailsForUnit:
  {
    permissionsId: '588f894d-81dc-45c7-0d6a-08d96c602a6b',
    permissionsName: 'View Reference details for unit',
    componentsId: null,
    components: null
  },

  EditReferenceDetailsForUnit:
  {
    permissionsId: '094b9aef-c11b-4015-0d6b-08d96c602a6b',
    permissionsName: 'Edit reference details for unit',
    componentsId: null,
    components: null
  },
  AddPaymentDetailsForUnit: {
    components: null,
    componentsId: null,
    permissionsId: 'e4bc89b8-c54c-44b7-9316-08d967db92be',
    permissionsName: 'Add Payment details for unit'
  },
  ViewPaymentDetailsForUnit: {
    components: null,
    componentsId: null,
    permissionsId: '24f018bc-3dea-4702-0d6c-08d96c602a6b',
    permissionsName: 'View Payment details for unit',
  },
  EditPaymentDetailsForUnit: {
    components: null,
    componentsId: null,
    permissionsId: 'd04bace4-76eb-45cd-0d6d-08d96c602a6b',
    permissionsName: 'Edit Payment details for unit'
  },
  DeletePaymentDetailsForUnit: {
    components: null,
    componentsId: null,
    permissionsId: 'a3653628-5c10-4577-0d6e-08d96c602a6b',
    permissionsName: 'delete Payment details for unit'
  },
  AddParkingForUnit: {
    components: null,
    componentsId: null,
    permissionsId: 'a00430f1-5752-4f94-9317-08d967db92be',
    permissionsName: 'Add parking for unit'
  },

  MakeTransactionOnUnitToBeAvailable: {
    components: null,
    componentsId: null,
    permissionsId: 'd3eb104b-4a70-4493-9318-08d967db92be',
    permissionsName: 'Make transaction on unit to be available'
  },

  MakeTransactionOnUnitToBeDraft: {
    components: null,
    componentsId: null,
    permissionsId: 'a34356f0-4da1-40a3-9319-08d967db92be',
    permissionsName: 'Make transaction on unit to be draft'
  },
  EditPaymentPlanForUnit: {
    permissionsId: 'd04bace4-76eb-45cd-0d6d-08d96c602a6b',
    permissionsName: 'Edit payment plan for unit',
    componentsId: null,
    components: null
  },

  DeletePaymentPlanForUnit:
  {
    permissionsId: 'a3653628-5c10-4577-0d6e-08d96c602a6b',
    permissionsName: 'Delete payment plan for unit',
    componentsId: null,
    components: null
  },
  ViewParkingInfoForUnit:
  {
    permissionsId: '7b37b3f3-50c8-439b-0d6f-08d96c602a6b',
    permissionsName: 'View parking info for unit',
    componentsId: null,
    components: null
  },
  DeleteOpenHouseForUnit:
  {
    permissionsId: '612c3546-0822-41f1-0d70-08d96c602a6b',
    permissionsName: 'Delete open house for unit',
    componentsId: null,
    components: null
  },
  ViewSaleDetailsForUnit:
  {
    permissionsId: 'fb049e70-0086-4050-0d68-08d96c602a6b',
    permissionsName: 'View sale details for unit',
    componentsId: null,
    components: null
  },
  ViewTheActivitiesForUnit:
  {
    permissionsId: '155443ba-c22b-4497-0d67-08d96c602a6b',
    permissionsName: 'View the activities for unit',
    componentsId: null,
    components: null
  },
  DeleteRemarksInUnit:
  {
    permissionsId: '8a6cfeb4-bf97-4df5-0d66-08d96c602a6b',
    permissionsName: 'Delete remarks in unit',
    componentsId: null,
    components: null
  },
  UpdateOpenHouseForUnit:
  {
    permissionsId: 'e2ef10a6-ba0b-4086-0d65-08d96c602a6b',
    permissionsName: 'Update open house for unit',
    componentsId: null,
    components: null
  },
  AddNewOpenHouseForUnit:
  {
    permissionsId: 'f831310b-ecfb-46f2-0d64-08d96c602a6b',
    permissionsName: 'Add new open house for unit',
    componentsId: null,
    components: null
  },
  ViewOpenHouseForUnit:
  {
    permissionsId: '79b7181d-5346-4e3e-0d63-08d96c602a6b',
    permissionsName: 'View open house for unit',
    componentsId: null,
    components: null
  },
  ViewRemarksForUnit:
  {
    permissionsId: '26122398-90db-4ab2-0d61-08d96c602a6b',
    permissionsName: 'View remarks for unit',
    componentsId: null,
    components: null
  },
  EditRemarksInUnit:
  {
    permissionsId: '16ac9b0c-21d0-4309-0d62-08d96c602a6b',
    permissionsName: 'edit remarks in unit',
    componentsId: null,
    components: null
  },

  UnitBulkUpdate:
  {
    permissionsId: '8aee795b-692f-4f26-0d5a-08d96c602a6b',
    permissionsName: 'Unit bulk update',
    componentsId: null,
    components: null
  },
  ViewUnitDetails:
  {
    permissionsId: 'deb70dcc-3936-4ed5-0d5b-08d96c602a6b',
    permissionsName: 'View unit details',
    componentsId: null,
    components: null
  },
  EditUnitDetails:
  {
    permissionsId: 'b126382e-f1b1-48df-0d5c-08d96c602a6b',
    permissionsName: 'Edit unit details',
    componentsId: null,
    components: null
  },
  ViewUnitImages:
  {
    permissionsId: '7517919c-ab3f-4ca8-0d5d-08d96c602a6b',
    permissionsName: 'View unit images',
    componentsId: null,
    components: null
  },
  ViewUnitLocationOnMap:
  {
    permissionsId: 'ef821283-c372-4c87-0d5e-08d96c602a6b',
    permissionsName: 'View unit location on map',
    componentsId: null,
    components: null
  },
  ViewUnitMarketingInfo:
  {
    permissionsId: '074f0be9-1a95-4269-0d5f-08d96c602a6b',
    permissionsName: 'View unit marketing info',
    componentsId: null,
    components: null
  },
  ViewDocumentsForUnit:
  {
    permissionsId: 'aa63bc0f-b7c8-41c2-0d60-08d96c602a6b',
    permissionsName: 'View documents for unit',
    componentsId: null,
    components: null
  },
  EditParkingForUnit:
  {
    permissionsId: 'c5588014-13f9-408b-bebb-08d96e04d1a0',
    permissionsName: 'Edit parking for unit',
    componentsId: null,
    components: null
  },
  DeleteParkingForUnit:
  {
    permissionsId: '826eda4c-da32-4f59-bebc-08d96e04d1a0',
    permissionsName: 'Delete parking for unit',
    componentsId: null,
    components: null
  },
  ViewUnitHistory:
  {
    permissionsId: '13c6f84e-a7ac-4591-bebd-08d96e04d1a0',
    permissionsName: 'View unit history',
    componentsId: null,
    components: null
  },
  ViewUnitTemplates:
  {
    permissionsId: 'ded3067b-4eed-440a-bebe-08d96e04d1a0',
    permissionsName: 'View unit templates',
    componentsId: null,
    components: null
  },
  OpenUnitTemplates:
  {
    permissionsId: 'b22ca106-1080-4849-bebf-08d96e04d1a0',
    permissionsName: 'Open unit templates',
    componentsId: null,
    components: null
  },
  SetUnitAsAvailableOrDraft:
  {
    permissionsId: '1df3c79a-0cce-43a3-bec3-08d96e04d1a0',
    permissionsName: 'set unit as available or draft',
    componentsId: null,
    components: null
  },
  ChekIfCanSetUnitAsReservedOrLeased:
  {
    permissionsId: 'aa56dcea-30c4-4914-bec4-08d96e04d1a0',
    permissionsName: 'Chek if can set unit as Reserved Or Leased',
    componentsId: null,
    components: null
  },
  SetUnitAsReserveOrLease:
  {
    permissionsId: '85ab06b5-353a-4a25-bec5-08d96e04d1a0',
    permissionsName: 'set unit as reserve Or Lease',
    componentsId: null,
    components: null
  }

};
